import React from 'react';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class DIOTwoImage extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    let twoImageBanner = null;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    let bannerLeftUrl =
      pagedetails.leftBanner.imageUrl.indexOf('?') == -1
        ? pagedetails.leftBanner.imageUrl
        : pagedetails.leftBanner.imageUrl.substr(0, pagedetails.leftBanner.imageUrl.indexOf('?'));
    let bannerRightUrl =
      pagedetails.rightBanner.imageUrl.indexOf('?') == -1
        ? pagedetails.rightBanner.imageUrl
        : pagedetails.rightBanner.imageUrl.substr(0, pagedetails.rightBanner.imageUrl.indexOf('?'));
    twoImageBanner = (
      <div className="image-banner row">
        <Col xs={6}>
          <a
            href={pagedetails.leftBanner.bannerUrlLink}
            className="img-animate"
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${pagedetails.leftBanner.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerLeftUrl}/${pagedetails.leftBanner.bannerPosition}`}
            data-gtm-bnr-position={`${pagedetails.leftBanner.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(pagedetails.leftBanner.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${pagedetails.leftBanner.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(pagedetails.leftBanner.imageUrl)}`} />
          </a>
        </Col>
        <Col xs={6}>
          <a
            href={pagedetails.rightBanner.bannerUrlLink}
            className="img-animate"
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${pagedetails.rightBanner.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerRightUrl}/${pagedetails.rightBanner.bannerPosition}`}
            data-gtm-bnr-position={`${pagedetails.rightBanner.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(
              pagedetails.rightBanner.imageUrl
            ) || ''}`}
            data-gtm-bnr-id={`${pagedetails.rightBanner.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(pagedetails.rightBanner.imageUrl)}`} />
          </a>
        </Col>
      </div>
    );
    return <div className="image-com">{twoImageBanner}</div>;
  }
}

export default BannerWrapper(DIOTwoImage);
